import React from 'react';

import {
    withStyles,
    ListItem,
    Grid,
    ListItemText,
    Typography,
    Button,
    ButtonBase,
    Snackbar,
} from '@material-ui/core';

import AppData from '../../model/AppData';
import MSnackbar from '../view/MSnackbar';
import MBack from '../view/MBack'; 
import DeviceEventEmitter, { EventName } from '../../control/event';
import Cancel from '@material-ui/icons/Cancel'

const styles = (theme) => ({
    commitBtn: {
        backgroundColor: '#4791db',
        borderRadius: 22.5,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    textfield: {
        backgroundColor: 'transparent',
        fontSize: 13,
        height: 30,
        marginLeft: 10,
        borderRadius: 10,
        width: '80%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(1, 1, 1, 1),
    },
});

class RealNameDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nickname: AppData.me.Username,
            nicknumber: '',
            phonenumber: '',
            checknumber: '',
            snackopened: false,
            message: '',
        };
        this._saveInfo = this._saveInfo.bind(this);
        this._getModifyInfoBack = this._getModifyInfoBack.bind(this);
        this._onCancel = this._onCancel.bind(this);
    }

    _saveInfo() {
        const { nickname,nicknumber,phonenumber,checknumber } = this.state;
        if (!nickname || nickname === '') {
            this.setState({ message: '昵称不能为空', snackopened: true });
            return;
        }

        if (!nicknumber || nicknumber === '') {
            this.setState({ message: '身份证号不能为空', snackopened: true });
            return;
        }

        if (!phonenumber || phonenumber === '') {
            this.setState({ message: '手机号码不能为空', snackopened: true });
            return;
        }

        if (!checknumber || checknumber === '') {
            this.setState({ message: '请输入验证码', snackopened: true });
            return;
        } 
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.ON_MODIFY_NAME, this._getModifyInfoBack, this);
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.ON_MODIFY_NAME, this._getModifyInfoBack, this);
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    _getModifyInfoBack(result) {
        if (result.RetCode === 0) {
            this.setState({ message: '信息修改成功', snackopened: true });
            this.timeout = setTimeout(() => {
                window.history.back();
            }, 2000);
        } else {
            this.setState({ message: '修改失败', snackopened: true });
        }
    }

    _onCancel() {
        this.setState({ nickname: '' });
    }

    // 个人信息
    render() {
        const { classes } = this.props;
        const { nickname, snackopened, message } = this.state;
        return (
            <MBack title="实名认证">
                <Grid style={{ height: 15 }}></Grid>
                <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 8 ,marginLeft:23 , marginRight:23}}>为了维护社区秩序和保证内容质量,发言需要实名认证,我们将确保您的隐私安全</Typography>} />
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 , width:70 }}>真是姓名</Typography>} />
                    <input
                        onChange={event => this.setState({ nickname: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='输入昵称'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 , width:70 }}>身份证号</Typography>} />
                    <input
                        onChange={event => this.setState({ nicknumber: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入身份证号码'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 , width:70 }}>手机号码</Typography>} />
                    <input
                        onChange={event => this.setState({ phonenumber: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入手机号码'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <ListItem disableRipple button style={{ backgroundColor: '#fff', height: 45 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 , width:70 }}>验证号码</Typography>} />
                    <input
                        onChange={event => this.setState({ checknumber: event.target.value })}
                        type='text'
                        className={classes.textfield}
                        placeholder='请输入验证码'
                    />
                    <Button style={{
                        position: 'absolute',
                        right: 0,
                    }} onClick={() => this._onCancel()}>
                        <Cancel style={{ color: '#E2E2E2', }}></Cancel>
                    </Button>
                </ListItem>
                <Grid style={{ height: 5 }}></Grid>
                <Grid container justify='center' >
                    <ButtonBase
                        className={classes.commitBtn}
                        onClick={this._saveInfo}
                    >提 交</ButtonBase>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack>
        );
    }
}

export default withStyles(styles)(RealNameDialog);